import PropTypes from 'prop-types';
import React, { Component } from 'react';
import OtherContributors from './other_contributors';
import FeaturedContributors from './featured_contributors';
import Breadcrumbs from './breadcrumbs';

export default class ArticleFooter extends Component {

  render() {
    const { nonFeaturedBylines, featuredBylines, openerImageCredit,
      breadcrumbs, meta_title
    } = this.props;

    return (
      <footer className="footer">
        <div className="byline"
          dangerouslySetInnerHTML={{ __html: meta_title }}
        />
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <FeaturedContributors bylines={featuredBylines} />
        <OtherContributors
          bylines={nonFeaturedBylines}
          openerImageCredit={openerImageCredit}
        />
      </footer>
    );
  }
}

ArticleFooter.propTypes = {
  featuredBylines: PropTypes.arrayOf(PropTypes.object.isRequired),
  nonFeaturedBylines: PropTypes.arrayOf(PropTypes.object.isRequired),
  openerImageCredit: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.object).isRequired,
  meta_title: PropTypes.string.isRequired
};
